(function initSuoDiagnosisData(root) {
  "use strict";

  const BASE_PRODUCTS = [
    {
      id: "suo-ring-28",
      name: "SUO RING 28°ICE",
      price_from: 2750,
      image: "assets/images/ring-28.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-ring-28-ice-2",
      tags: ["user_adult", "area_neck", "cool_gentle", "cool_mild", "use_commute", "use_indoor", "pri_price", "pri_lightness", "first_buy"],
      description: "じんわり優しい冷たさで、日常使いに取り入れやすい定番リング。"
    },
    {
      id: "suo-ring-plus-28",
      name: "SUO RING Plus 28°ICE",
      price_from: 3300,
      image: "assets/images/ring-plus-28.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-ring-plus-28-ice",
      tags: ["user_adult", "area_neck", "cool_gentle", "cool_mild", "use_commute", "use_event", "pri_duration", "replace_longer"],
      description: "通常より容量が大きいPlusタイプ。持続時間を重視したい方に。"
    },
    {
      id: "suo-ring-plus-18",
      name: "SUO RING Plus 18°ICE",
      price_from: 3300,
      image: "assets/images/ring-plus-18.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-ring-plus-18-ice-1",
      tags: ["user_adult", "area_neck", "cool_strong", "use_outdoor_work", "use_sports", "pri_cooling_power", "pri_duration", "replace_more_cold"],
      description: "しっかり冷たさを感じられる18°ICEタイプ。暑がりさんや屋外シーンに。"
    },
    {
      id: "suo-ring-button-28",
      name: "SUO RING 28°ICE ボタン付",
      price_from: 3410,
      image: "assets/images/ring-button.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-ring-28-ice-star-button-1",
      tags: ["user_adult", "user_child", "area_neck", "sports_high", "pri_fit", "replace_fit"],
      description: "ボタンで固定しやすく、外れにくさを重視したいお子さまやスポーツ用途に。"
    },
    {
      id: "suo-wband-18",
      name: "SUO WBAND 18°ICE",
      price_from: 3300,
      image: "assets/images/wband-18.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-18-ice-suo-wband-2",
      tags: ["user_adult", "area_neck", "cool_strong", "use_sports", "use_outdoor_work", "sports_high", "pri_fit", "pri_cooling_power", "replace_more_cold", "replace_fit"],
      description: "広い面積で首元にフィット。動きのあるシーンでしっかり冷たさを求める方に。"
    },
    {
      id: "suo-wband-28",
      name: "SUO WBAND 28°ICE",
      price_from: 3300,
      image: "assets/images/wband-28.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-28-ice-wband",
      tags: ["user_adult", "area_neck", "cool_gentle", "use_sports", "use_commute", "sports_high", "pri_fit", "replace_fit"],
      description: "広い面積で首元にフィット。動きのあるシーンに、優しい冷たさで。"
    },
    {
      id: "suo-oval-18",
      name: "SUO 18°ICE OVAL RING 2",
      price_from: 3740,
      image: "assets/images/oval-18.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-18-ice-oval-ring-2",
      tags: ["user_adult", "area_neck", "cool_strong", "use_sports", "use_outdoor_work", "sports_high", "pri_fit", "pri_cooling_power", "replace_more_cold", "replace_fit"],
      description: "オーバル形状で、首元や手首・足首まわりのフィット感を重視したい方に。"
    },
    {
      id: "suo-ring-hawaii-button",
      name: "SUO RING 28°ICE hawaii ボタン付",
      price_from: 3410,
      image: "assets/images/ring-hawaii.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-ring-28-ice-hawaii-button",
      tags: ["user_adult", "area_neck", "pri_design", "pri_fit", "gift_yes", "use_event", "cool_gentle", "replace_design"],
      description: "ハワイ柄の意匠とボタン付の機能性を両立。ギフトにも選びやすいタイプ。"
    },
    {
      id: "suo-ring-reflector",
      name: "SUO RING 28°ICE reflector",
      price_from: 2750,
      image: "assets/images/ring-reflector.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-ring-28-ice-reflector",
      tags: ["user_adult", "user_child", "area_neck", "use_commute", "use_sports", "pri_lightness", "pri_night_visibility", "cool_gentle"],
      description: "反射板付き。夜間の散歩や自転車通勤・通学で見えやすさも気にしたい方に。"
    },
    {
      id: "suo-256ice-cap",
      name: "SUO 256ICE CAP",
      price_from: 3520,
      image: "assets/images/256-cap.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-256ice-cap-1",
      tags: ["user_adult", "area_head", "use_outdoor_work", "use_sports", "sports_high", "cool_strong", "pri_cooling_power"],
      description: "帽子・ヘルメット周りの暑さが気になる屋外作業やスポーツ向け。"
    },
    {
      id: "suo-256ice-chokki",
      name: "SUO 256ICE チョッキ",
      price_from: 13200,
      image: "assets/images/256-chokki.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-256ice-chokki",
      tags: ["user_adult", "area_back", "use_outdoor_work", "use_event", "cool_strong", "pri_cooling_power", "pri_duration", "replace_more_cold", "replace_longer"],
      description: "背中・体幹を広範囲で冷やしたい本格派ベスト。"
    },
    {
      id: "suo-cool-mat",
      name: "SUO 28°ICE COOL Mat",
      price_from: 4730,
      image: "assets/images/cool-mat.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-28-ice-cool-mat",
      tags: ["user_adult", "area_mat", "use_indoor", "sports_low", "cool_gentle", "cool_mild", "pri_duration"],
      description: "敷いて使える28°ICEマット。室内や座面で使いたい方に。"
    },
    {
      id: "suo-multi-seat",
      name: "SUO 28° ICE MULTI SEAT",
      price_from: 3278,
      image: "assets/images/multi-seat.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-28-ice-multi-sheet",
      tags: ["user_adult", "user_baby", "area_mat", "baby_car", "baby_indoor", "use_event", "sports_low", "cool_gentle"],
      description: "ベビーカー・チャイルドシート・椅子など幅広く使えるマルチシート。"
    },
    {
      id: "suo-babycar",
      name: "SUO 28°ICE BABY CAR COOL SEAT",
      price_from: 3278,
      image: "assets/images/babycar.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-28-ice-babycar-coolseat",
      tags: ["user_baby", "area_mat", "baby_car", "use_event", "sports_low", "cool_gentle"],
      description: "ベビーカー専用設計のクールシート。お出かけ時の座面まわりに。"
    },
    {
      id: "suo-pet-ring-button",
      name: "SUO RING for dogs 28°ICE star ボタン付",
      price_from: 2640,
      image: "assets/images/pet-ring.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-ring-28-ice-for-dogs-button",
      tags: ["user_pet", "pet_dog", "area_neck", "use_sports", "pri_fit", "sports_high", "cool_gentle", "replace_fit"],
      description: "ワンちゃん専用設計。ボタン付で外れにくさを重視したい散歩時に。"
    },
    {
      id: "suo-pet-vest",
      name: "SUO 256 ICE for dogs COOL Vest",
      price_from: 3960,
      image: "assets/images/pet-vest.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-256-ice-for-dogs-cool-vest",
      tags: ["user_pet", "pet_dog", "pet_large_dog", "area_back", "pri_cooling_power", "cool_strong", "use_sports"],
      description: "犬用クールベスト。散歩中の背中まわりの暑さが気になるときに。"
    },
    {
      id: "suo-pet-mat",
      name: "SUO 28°ICE COOL Mat2 (for dogs)",
      price_from: 5060,
      image: "assets/images/pet-mat.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-28-ice-cool-mat2-1",
      tags: ["user_pet", "pet_dog", "pet_cat", "area_mat", "use_indoor", "sports_low", "cool_gentle", "pri_duration"],
      description: "犬・猫用クールマット。室内のお昼寝スペースに。"
    },
    {
      id: "suo-sumikko",
      name: "SUO RING 28°ICE すみっコぐらし",
      price_from: 2530,
      image: "assets/images/sumikko.jpg",
      url: "https://ec-life.suo.co.jp/products/suo-ring-28-ice-sumikko",
      tags: ["user_child", "child_preschool", "child_school", "area_neck", "use_commute", "use_event", "pri_design", "cool_gentle", "first_buy", "replace_design"],
      description: "すみっコぐらしコラボ。お子さまが身につけやすいデザイン。"
    },
    {
      id: "suo-expo",
      name: "EXPO2025 ミャクミャク SUO RING プラス 28°ICE",
      price_from: 3300,
      image: "assets/images/expo.jpg",
      url: "https://ec-life.suo.co.jp/products/expo2025-suo-ring-puls-28-ice",
      tags: ["user_adult", "user_child", "area_neck", "pri_design", "gift_yes", "cool_gentle", "use_event", "replace_design"],
      description: "大阪・関西万博公式コラボ。記念ギフトにも選びやすいデザイン。"
    }
  ];

  function getRmsProduct(legacyId) {
    const catalog = root.SUO_RMS_CATALOG;
    if (!catalog) return null;
    const itemId = catalog.legacy_mapping[legacyId];
    return catalog.products.find((product) => product.item_id === itemId) || null;
  }

  function getSizingDefinition(itemId) {
    const table = root.SUO_SIZING_TABLE;
    if (!table || !itemId) return null;
    return table[itemId] || null;
  }

  function enrichProduct(product) {
    const rms = getRmsProduct(product.id);
    if (!rms) return product;
    return {
      ...product,
      available: rms.available,
      url: rms.url || product.url,
      price_from: rms.price_from || product.price_from,
      image: rms.image || product.image,
      rms_item_id: rms.item_id,
      rms_series_id: rms.series_id,
      rms_specs: rms.specs,
      rms_skus: rms.skus,
      sales_units: rms.sales_units || 0,
      sizing: getSizingDefinition(rms.item_id)
    };
  }

  const PRODUCTS = BASE_PRODUCTS.map(enrichProduct);

  const COMMON_QUESTIONS = [
    {
      id: "usage",
      number: 1,
      title: "主にどんな場面で使いますか?",
      key: "usage",
      options: [
        { id: "q1-a", label: "通勤・通学", tag: "use_commute", icon: "train" },
        { id: "q1-b", label: "屋外作業", tag: "use_outdoor_work", icon: "helmet" },
        { id: "q1-c", label: "スポーツ・散歩", tag: "use_sports", icon: "run" },
        { id: "q1-d", label: "室内・デスク", tag: "use_indoor", icon: "desk" },
        { id: "q1-e", label: "フェス・お出かけ", tag: "use_event", icon: "sun" }
      ]
    },
    {
      id: "area",
      number: 2,
      title: "主に冷やしたい場所はどこですか?",
      key: "area",
      options: [
        { id: "q2-a", label: "首元", tag: "area_neck", icon: "neck" },
        { id: "q2-b", label: "背中・体幹", tag: "area_back", icon: "vest" },
        { id: "q2-c", label: "頭・帽子の中", tag: "area_head", icon: "cap" },
        { id: "q2-d", label: "敷いて使いたい", tag: "area_mat", icon: "mat" }
      ]
    },
    {
      id: "sports",
      number: 3,
      title: "使用中にどのくらい動きますか?",
      key: "sports",
      options: [
        { id: "q3-a", label: "しっかり動く", tag: "sports_high", icon: "fit" },
        { id: "q3-b", label: "歩く程度", tag: "sports_medium", icon: "walk" },
        { id: "q3-c", label: "ほとんど動かない", tag: "sports_low", icon: "relax" }
      ]
    },
    {
      id: "cool",
      number: 4,
      title: "冷たさの好みを教えてください",
      key: "cool",
      options: [
        { id: "q4-a", label: "じんわり優しい", tag: "cool_gentle", icon: "soft" },
        { id: "q4-b", label: "しっかり冷たい", tag: "cool_strong", icon: "ice" },
        { id: "q4-c", label: "冷たすぎるのは苦手", tag: "cool_mild", icon: "mild" },
        { id: "q4-d", label: "おまかせ", tag: "cool_any", icon: "auto" }
      ]
    },
    {
      id: "priority",
      number: 5,
      title: "いちばん重視したいことは?",
      key: "priority",
      options: [
        { id: "q5-a", label: "持続時間", tag: "pri_duration", icon: "clock" },
        { id: "q5-b", label: "ズレにくさ", tag: "pri_fit", icon: "lock" },
        { id: "q5-c", label: "軽さ", tag: "pri_lightness", icon: "feather" },
        { id: "q5-d", label: "見た目", tag: "pri_design", icon: "sparkle" },
        { id: "q5-e", label: "価格", tag: "pri_price", icon: "yen" },
        { id: "q5-f", label: "冷たさの強さ", tag: "pri_cooling_power", icon: "snow" },
        { id: "q5-g", label: "夜間の見えやすさ", tag: "pri_night_visibility", icon: "reflect" }
      ]
    },
    {
      id: "ownership",
      number: 6,
      title: "クールリングは初めてですか?",
      key: "ownership",
      options: [
        { id: "q6-a", label: "初めて買う", tag: "first_buy", icon: "new" },
        { id: "q6-b", label: "すでに持っている", tag: "has_ring", icon: "ring" }
      ]
    }
  ];

  const REPLACEMENT_QUESTION = {
    id: "replacement_need",
    number: 7,
    title: "今のものから変えたいポイントは?",
    key: "replacement_need",
    options: [
      { id: "q7-r-a", label: "もっと冷たさがほしい", tag: "replace_more_cold", icon: "cold" },
      { id: "q7-r-b", label: "もっと長く使いたい", tag: "replace_longer", icon: "long" },
      { id: "q7-r-c", label: "もっと外れにくくしたい", tag: "replace_fit", icon: "button" },
      { id: "q7-r-d", label: "デザインを変えたい", tag: "replace_design", icon: "sparkle" }
    ]
  };

  const SIZE_QUESTION = {
    id: "neck_size",
    number: 3,
    title: "ふだん着る服のサイズに近いのは?",
    key: "size",
    options: [
      { id: "q-size-a", label: "S", tag: "size_s", icon: "measure" },
      { id: "q-size-b", label: "M", tag: "size_m", icon: "measure" },
      { id: "q-size-c", label: "L", tag: "size_l", icon: "measure" },
      { id: "q-size-d", label: "LL以上", tag: "size_ll", icon: "measure" },
      { id: "q-size-e", label: "わからない", tag: "size_unknown", icon: "auto" }
    ]
  };

  // Asked only in the adult neck flow, right before SIZE_QUESTION: neck
  // circumference differs by ~5cm between adult men and women, so clothing size
  // alone cannot resolve a ring size. 回答しない falls back to a unisex estimate.
  const GENDER_QUESTION = {
    id: "gender",
    number: 3,
    title: "性別を教えてください",
    key: "gender",
    options: [
      { id: "q-gender-a", label: "女性", tag: "gender_female", icon: "self" },
      { id: "q-gender-b", label: "男性", tag: "gender_male", icon: "self" },
      { id: "q-gender-c", label: "回答しない", tag: "gender_na", icon: "auto" }
    ]
  };

  const PET_SIZE_QUESTION = {
    id: "pet_neck_size",
    number: 3,
    title: "愛犬の大きさに近いのは?",
    key: "pet_size",
    options: [
      { id: "q-petsize-a", label: "超小型犬（〜4kg目安）", tag: "size_s", icon: "dog" },
      { id: "q-petsize-b", label: "小型犬（〜10kg目安）", tag: "size_m", icon: "dog" },
      { id: "q-petsize-c", label: "中型犬（〜25kg目安）", tag: "size_l", icon: "dog" },
      { id: "q-petsize-d", label: "大型犬（25kg〜目安）", tag: "size_ll", icon: "large-dog" },
      { id: "q-petsize-e", label: "わからない", tag: "size_unknown", icon: "auto" }
    ]
  };

  const PET_QUESTIONS = [
    {
      id: "pet_area",
      number: 1,
      title: "ペットのどこを冷やしたいですか?",
      key: "area",
      options: [
        { id: "q-pet-1-a", label: "首元", tag: "area_neck", icon: "neck" },
        { id: "q-pet-1-b", label: "背中", tag: "area_back", icon: "vest" },
        { id: "q-pet-1-c", label: "敷いて使う", tag: "area_mat", icon: "mat" }
      ]
    },
    {
      id: "pet_scene",
      number: 2,
      title: "主にどんな場面で使いますか?",
      key: "usage",
      options: [
        { id: "q-pet-2-a", label: "散歩", tag: "use_sports", icon: "walk" },
        { id: "q-pet-2-b", label: "室内", tag: "use_indoor", icon: "room" },
        { id: "q-pet-2-c", label: "車・お出かけ", tag: "use_event", icon: "sun" }
      ]
    },
    {
      id: "pet_priority",
      number: 3,
      title: "いちばん重視したいことは?",
      key: "priority",
      options: [
        { id: "q-pet-3-a", label: "外れにくさ", tag: "pri_fit", icon: "lock" },
        { id: "q-pet-3-b", label: "しっかり冷やしたい", tag: "pri_cooling_power", icon: "snow" },
        { id: "q-pet-3-c", label: "休む場所を涼しくしたい", tag: "pri_duration", icon: "mat" }
      ]
    }
  ];

  const BABY_QUESTIONS = [
    {
      id: "baby_place",
      number: 1,
      title: "赤ちゃんまわりのどこで使いますか?",
      key: "extra",
      options: [
        { id: "q-baby-1-a", label: "ベビーカー", tag: "baby_car", icon: "stroller" },
        { id: "q-baby-1-b", label: "チャイルドシート", tag: "baby_car", icon: "seat" },
        { id: "q-baby-1-c", label: "室内", tag: "baby_indoor", icon: "room" }
      ]
    },
    {
      id: "baby_area",
      number: 2,
      title: "使い方はどれに近いですか?",
      key: "area",
      options: [
        { id: "q-baby-2-a", label: "敷いて使う", tag: "area_mat", icon: "mat" },
        { id: "q-baby-2-b", label: "座面に使う", tag: "area_mat", icon: "seat" }
      ]
    },
    {
      id: "baby_priority",
      number: 3,
      title: "いちばん重視したいことは?",
      key: "priority",
      options: [
        { id: "q-baby-3-a", label: "敷きやすさ", tag: "pri_fit", icon: "fit" },
        { id: "q-baby-3-b", label: "持ち運び", tag: "pri_lightness", icon: "feather" },
        { id: "q-baby-3-c", label: "やさしい冷たさ", tag: "cool_gentle", icon: "soft" }
      ]
    },
    {
      id: "baby_frequency",
      number: 4,
      title: "どのくらい使う予定ですか?",
      key: "usage",
      options: [
        { id: "q-baby-4-a", label: "毎日", tag: "use_indoor", icon: "calendar" },
        { id: "q-baby-4-b", label: "お出かけ中心", tag: "use_event", icon: "sun" },
        { id: "q-baby-4-c", label: "暑い日だけ", tag: "use_event", icon: "auto" }
      ]
    }
  ];

  const EXTRA_QUESTIONS = {
    user_adult: {
      id: "adult_extra",
      number: 8,
      title: "プレゼント用ですか?",
      key: "extra",
      options: [
        { id: "q8-a", label: "はい", tag: "gift_yes", icon: "gift" },
        { id: "q8-b", label: "いいえ", tag: "gift_no", icon: "self" }
      ]
    },
    user_child: {
      id: "child_extra",
      number: 8,
      title: "お子さまの年齢層は?",
      key: "extra",
      options: [
        { id: "q8-c", label: "未就学児", tag: "child_preschool", icon: "child-small" },
        { id: "q8-d", label: "小学生以上", tag: "child_school", icon: "child-school" }
      ]
    },
    user_pet: {
      id: "pet_extra",
      number: 4,
      title: "ペットの種類を教えてください",
      key: "extra",
      options: [
        { id: "q7-e", label: "犬", tag: "pet_dog", icon: "dog" },
        { id: "q7-f", label: "猫", tag: "pet_cat", icon: "cat" },
        { id: "q7-g", label: "大型犬", tag: "pet_large_dog", icon: "large-dog" }
      ]
    },
    user_baby: null
  };

  const USER_OPTIONS = [
    { id: "q0-a", label: "大人", tag: "user_adult" },
    { id: "q0-b", label: "子ども", tag: "user_child" },
    { id: "q0-c", label: "ペット", tag: "user_pet" },
    { id: "q0-d", label: "赤ちゃん", tag: "user_baby" }
  ];

  const RESULT_NOTES = {
    user_pet: "※ 噛み癖がある場合は使用を中止してください。目の届かない場所での使用は避けてください。",
    user_baby: "※ 使用中は赤ちゃんの様子を確認し、商品ページの対象月齢・使用方法をご確認ください。"
  };

  const SIZE_GUIDES = {
    default: "首まわりをやわらかいメジャーで測り、きつすぎず浮きすぎないサイズを商品ページのサイズ表で確認してください。迷う場合は、使用シーンとフィット感を優先して選ぶのがおすすめです。",
    user_child: "お子さまは成長や服装でフィット感が変わります。首まわり実寸を測り、余裕がありすぎないサイズを商品ページのサイズ表で確認してください。",
    user_pet: "ペットは首まわりや胴まわりを実測し、毛量や動きやすさも見てサイズ表と照合してください。苦しそうな場合や嫌がる場合は使用を避けてください。",
    user_baby: "ベビーカーやシートで使う商品は、設置場所の寸法と固定方法を商品ページで確認してください。体に直接巻くサイズ提案は行いません。"
  };

  const RANK_LABELS = ["一番おすすめ", "次点", "迷ったら"];

  const MATCH_LABELS = {
    area_neck: "首元に合う",
    area_back: "背中・体幹向き",
    area_head: "頭まわり向き",
    area_mat: "敷いて使える",
    use_commute: "通勤・通学",
    use_outdoor_work: "屋外作業",
    use_sports: "スポーツ・散歩",
    use_indoor: "室内・デスク",
    use_event: "お出かけ",
    sports_high: "動いても使いやすい",
    sports_low: "据え置きで使いやすい",
    cool_gentle: "やさしい冷たさ",
    cool_strong: "しっかり冷たい",
    cool_mild: "冷たすぎにくい",
    pri_duration: "持続時間重視",
    pri_fit: "フィット感重視",
    pri_lightness: "軽さ重視",
    pri_design: "デザイン重視",
    pri_price: "価格重視",
    pri_cooling_power: "冷たさ重視",
    pri_night_visibility: "夜間にも使いやすい",
    first_buy: "初めてでも選びやすい",
    replace_more_cold: "買い替え: 冷たさ",
    replace_longer: "買い替え: 持続時間",
    replace_fit: "買い替え: フィット",
    replace_design: "買い替え: デザイン",
    gift_yes: "ギフト向き",
    child_preschool: "未就学児向き",
    child_school: "小学生以上向き",
    pet_dog: "犬向き",
    pet_cat: "猫向き",
    pet_large_dog: "大型犬向き",
    baby_car: "ベビーカー向き",
    baby_indoor: "室内向き"
  };

  const ANSWER_LABELS = {
    user_adult: "大人用",
    user_child: "子ども用",
    user_pet: "ペット用",
    user_baby: "赤ちゃんまわり",
    area_neck: "首元を冷やしたい",
    area_back: "背中・体幹を冷やしたい",
    area_head: "頭まわりを冷やしたい",
    area_mat: "敷いて使いたい",
    use_commute: "通勤・通学で使いたい",
    use_outdoor_work: "屋外作業で使いたい",
    use_sports: "スポーツ・散歩で使いたい",
    use_indoor: "室内で使いたい",
    use_event: "お出かけで使いたい",
    gender_female: "女性",
    gender_male: "男性",
    cool_gentle: "やさしい冷たさが好み",
    cool_strong: "しっかり冷たいものが好み",
    cool_mild: "冷たすぎるのは苦手",
    pri_duration: "持続時間を重視",
    pri_fit: "フィット感を重視",
    pri_lightness: "軽さを重視",
    pri_design: "デザインを重視",
    pri_price: "価格を重視",
    pri_cooling_power: "冷たさの強さを重視",
    pri_night_visibility: "夜間の見えやすさを重視",
    replace_more_cold: "買い替えで冷たさを上げたい",
    replace_longer: "買い替えで持続時間を上げたい",
    replace_fit: "買い替えで外れにくさを上げたい",
    replace_design: "買い替えでデザインを変えたい"
  };

  // Users rarely know their neck circumference, so the size question asks something
  // they DO know — their usual clothing size (or, for pets, the dog's body size).
  // We translate that answer into a plausible neck-circumference range (cm), take
  // its midpoint, and resolveSizeForProduct matches it to the per-product bands.
  // Adults are split by gender (typical Japanese body-neck averages: women ≈31-32cm,
  // men ≈36-37cm — the old unisex table S33/M36/L39/LL42 tracked men's shirt-collar
  // sizes and over-sized every woman). "default" is the unisex blend used for
  // 回答しない / missing gender. Values are anthropometric estimates pending client
  // confirmation. Child/pet midpoints intentionally equal the previous point table.
  const NECK_RANGE_BY_AUDIENCE = {
    user_adult: {
      gender_female: { size_s: [28, 31], size_m: [30, 33], size_l: [32, 36], size_ll: [35, 40] },
      gender_male: { size_s: [32, 35], size_m: [35, 38], size_l: [37, 41], size_ll: [40, 46] },
      default: { size_s: [30, 33], size_m: [32, 36], size_l: [35, 39], size_ll: [38, 44] }
    },
    user_child: { size_s: [25, 27], size_m: [28, 30], size_l: [31, 33], size_ll: [34, 36] },
    user_pet: { size_s: [16, 20], size_m: [21, 25], size_l: [27, 31], size_ll: [34, 40] }
  };

  const SIZE_FALLBACK_MESSAGE = "商品ページのサイズ表でご確認ください";

  // Answer tags that intentionally score nothing: they shape the flow ("has_ring"),
  // represent "no preference" ("cool_any"), or a non-boosting choice ("sports_low").
  // The vocabulary-invariant test treats these as exempt from the "must match a
  // product" rule. Size tags drive SKU selection, not product scoring.
  const NEUTRAL_TAGS = new Set([
    "cool_any", "sports_medium", "has_ring", "gift_no",
    "size_s", "size_m", "size_l", "size_ll", "size_unknown",
    "gender_female", "gender_male", "gender_na"
  ]);

  // Max ranking boost (in score points) the single best-selling eligible product
  // gets; others scale by sqrt(units / topUnits). Currently 0 — the best-seller
  // bias is disabled, so ranking is purely fit-based with a price tiebreak. Set
  // this back to ~25 and supply a Shopify sales export (--sales) to re-enable it.
  const POPULARITY_WEIGHT = 0;

  function getWeight(tag) {
    if (tag.indexOf("user_") === 0) return 100;
    if (tag.indexOf("area_") === 0) return 50;
    if (tag.indexOf("pri_") === 0) return 30;
    if (tag.indexOf("use_") === 0) return 25;
    if (tag.indexOf("sports_") === 0) return 25;
    if (tag.indexOf("replace_") === 0) return 25;
    if (tag.indexOf("cool_") === 0) return 20;
    if (tag.indexOf("gift_") === 0 || tag.indexOf("pet_") === 0 || tag.indexOf("child_") === 0 || tag.indexOf("baby_") === 0) return 15;
    if (tag.indexOf("size_") === 0) return 10;
    return 1;
  }

  function normalizeTags(selectedTags) {
    const tags = new Set(selectedTags.filter(Boolean));
    // "おまかせ" (no cooling preference) must not score against any product.
    tags.delete("cool_any");
    return Array.from(tags);
  }

  function isEligible(product, selectedTags) {
    const tags = new Set(selectedTags);
    if (product.available === false) return false;
    if ((product.requiredTags || []).some((tag) => !tags.has(tag))) return false;
    if ((product.excludedTags || []).some((tag) => tags.has(tag))) return false;
    if (tags.has("user_pet")) return product.tags.includes("user_pet");
    if (tags.has("user_baby")) return product.tags.includes("user_baby");
    if (tags.has("user_child")) return product.tags.includes("user_child") || product.tags.includes("user_adult");
    if (tags.has("user_adult")) return product.tags.includes("user_adult");
    return true;
  }

  function calcScore(product, selectedTags) {
    const baseScore = selectedTags.reduce((score, tag) => {
      return product.tags.includes(tag) ? score + getWeight(tag) : score;
    }, 0);
    const tagSet = new Set(selectedTags);
    const isBabyDedicated = tagSet.has("user_baby") && product.tags.includes("user_baby") && !product.tags.includes("user_adult");
    return baseScore + (isBabyDedicated ? 10 : 0);
  }

  function getRecommendationReason(product, selectedTags) {
    const tagSet = new Set(selectedTags);
    const reasons = [];

    if (tagSet.has("use_sports") || tagSet.has("sports_high")) {
      if (product.tags.includes("pri_fit") || product.tags.includes("sports_high")) reasons.push("動きのあるシーンでフィット感を重視しやすいタイプです。");
    }
    if (tagSet.has("replace_more_cold") && product.tags.includes("cool_strong")) reasons.push("今のリングより冷たさをしっかり感じたい買い替え候補です。");
    if (tagSet.has("replace_longer") && product.tags.includes("pri_duration")) reasons.push("持続時間を重視したい買い替えに向いています。");
    if (tagSet.has("replace_fit") && product.tags.includes("pri_fit")) reasons.push("外れにくさやフィット感を見直したい方に合いやすい候補です。");
    if (tagSet.has("replace_design") && product.tags.includes("pri_design")) reasons.push("今のリングから雰囲気を変えたい方に選びやすいデザインです。");
    if (tagSet.has("pri_night_visibility") && product.tags.includes("pri_night_visibility")) reasons.push("夜間の散歩や自転車移動で見えやすさも考えたい方に。");
    if (tagSet.has("area_head") && product.tags.includes("area_head")) reasons.push("帽子やヘルメットまわりの暑さが気になる方に。");
    if (tagSet.has("area_back") && product.tags.includes("area_back")) reasons.push("背中や体幹を広めに冷やしたい方に。");
    if (tagSet.has("area_mat") && product.tags.includes("area_mat")) reasons.push("座面や寝具、ベビーカーまわりで敷いて使いたい方に。");

    reasons.push(product.description);
    return reasons.slice(0, 2).join(" ");
  }

  function getMatchTags(product, selectedTags) {
    const seen = new Set();
    return selectedTags
      .filter((tag) => product.tags.includes(tag) && MATCH_LABELS[tag])
      .map((tag) => MATCH_LABELS[tag])
      .filter((label) => {
        if (seen.has(label)) return false;
        seen.add(label);
        return true;
      })
      .slice(0, 6);
  }

  function measuresFromTags(selectedTags) {
    const tags = new Set(selectedTags);
    const userType = selectedTags.find((tag) => tag.indexOf("user_") === 0);
    let scale = NECK_RANGE_BY_AUDIENCE[userType] || NECK_RANGE_BY_AUDIENCE.user_adult;
    if (scale.default) {
      // Adult table is gender-keyed; gender_na or a missing answer uses the
      // unisex default deliberately (skewing it smaller would under-size men
      // who decline to answer).
      const genderTag = ["gender_female", "gender_male"].find((tag) => tags.has(tag));
      scale = scale[genderTag] || scale.default;
    }
    const sizeTag = ["size_s", "size_m", "size_l", "size_ll"].find((tag) => tags.has(tag));
    const range = sizeTag ? scale[sizeTag] : null;
    return { neck_cm: range ? (range[0] + range[1]) / 2 : null, weight_kg: null };
  }

  // Half-open (min, max]: a value on a shared band boundary belongs to the
  // SMALLER band. Max-exclusive would push boundary necks into the larger size —
  // the exact complaint ("too big") this convention exists to prevent.
  function withinRange(range, value) {
    if (!range || value == null) return false;
    const min = range[0];
    const max = range[1];
    if (min != null && value <= min) return false;
    if (max != null && value > max) return false;
    return true;
  }

  // Sort key: neck min ascending (open-low first), then neck max ascending
  // (open-high last). Neck-only on purpose — every generated table today is
  // measure_type "neck"; revisit if a weight/both table ever appears.
  function bandNeckSortKey(band) {
    const range = band.neck || [null, null];
    return [
      range[0] == null ? -Infinity : range[0],
      range[1] == null ? Infinity : range[1]
    ];
  }

  // Map a user's real measurement to a recommended size/SKU using the
  // client-authored definition table. When no definition exists, the measurement
  // is missing, or it falls outside every band, return a neutral fallback so the
  // UI links to the size chart instead of fabricating a size.
  function resolveSizeForProduct(product, userMeasures) {
    const sizing = product.sizing;
    const measures = userMeasures || {};
    if (!sizing || !Array.isArray(sizing.bands) || !sizing.bands.length) {
      return { fallback: true, message: SIZE_FALLBACK_MESSAGE };
    }
    // Smallest matching band always wins: sort by neck range instead of trusting
    // CSV/generator row order, so deliberately overlapping bands (WBAND M/L) and
    // shared boundaries resolve to the smaller size.
    const bands = sizing.bands.slice().sort((a, b) => {
      // Compare, don't subtract: two open-ended bounds would yield NaN.
      const ka = bandNeckSortKey(a);
      const kb = bandNeckSortKey(b);
      if (ka[0] !== kb[0]) return ka[0] < kb[0] ? -1 : 1;
      if (ka[1] !== kb[1]) return ka[1] < kb[1] ? -1 : 1;
      return 0;
    });
    const band = bands.find((candidate) => {
      if (sizing.measure_type === "weight") return withinRange(candidate.weight, measures.weight_kg);
      if (sizing.measure_type === "both") {
        return withinRange(candidate.neck, measures.neck_cm) || withinRange(candidate.weight, measures.weight_kg);
      }
      return withinRange(candidate.neck, measures.neck_cm);
    });
    if (!band) return { fallback: true, message: SIZE_FALLBACK_MESSAGE };
    const sku = (product.rms_skus || []).find((candidate) => candidate.sku_id === band.sku_id) || null;
    return { fallback: false, size_label: band.size_label, sku_id: band.sku_id, sku };
  }

  function calculateRecommendations(selectedTags, limit) {
    const normalizedTags = normalizeTags(selectedTags);
    const measures = measuresFromTags(normalizedTags);
    const scored = PRODUCTS
      .filter((product) => isEligible(product, normalizedTags))
      .map((product) => {
        const size = resolveSizeForProduct(product, measures);
        return {
          ...product,
          score: calcScore(product, normalizedTags),
          reason: getRecommendationReason(product, normalizedTags),
          matchTags: getMatchTags(product, normalizedTags),
          size,
          recommendedSku: size.fallback ? null : size.sku
        };
      })
      .filter((product) => product.score > 0);

    // Best-seller bias: nudge popular products up the ranking (and decide ties)
    // without changing the displayed fit %. Fit weights are large, so popularity
    // mainly settles close calls — it surfaces best-sellers without overriding fit.
    const maxUnits = scored.reduce((max, product) => Math.max(max, product.sales_units || 0), 0) || 1;
    scored.forEach((product) => {
      product.rankScore = product.score + POPULARITY_WEIGHT * Math.sqrt((product.sales_units || 0) / maxUnits);
    });

    const recommendations = scored
      .sort((a, b) => {
        if (b.rankScore !== a.rankScore) return b.rankScore - a.rankScore;
        if ((b.sales_units || 0) !== (a.sales_units || 0)) return (b.sales_units || 0) - (a.sales_units || 0);
        return a.price_from - b.price_from;
      })
      .filter((product, index, products) => {
        const seriesId = product.rms_series_id;
        if (!seriesId) return true;
        return products.findIndex((candidate) => candidate.rms_series_id === seriesId) === index;
      })
      .slice(0, limit || 3);
    // Relative fit: the top candidate is the 100% reference and the rest are scored
    // proportionally. This is honest (the winner is always the best of the eligible
    // set) and avoids the old confidence metric whose denominator counted answer
    // tags no product could satisfy, making even the best match look weak.
    const topScore = recommendations[0] ? recommendations[0].score : 1;
    return recommendations.map((product, index) => ({
      ...product,
      rank: index + 1,
      rankLabel: RANK_LABELS[index] || `${index + 1}位`,
      matchPercent: Math.min(100, Math.max(1, Math.round((product.score / topScore) * 100)))
    }));
  }

  function getQuestionFlow(userType) {
    const answers = arguments.length > 1 ? arguments[1] : {};

    if (userType === "user_pet") {
      const petFlow = PET_QUESTIONS.slice();
      if (answers.area === "area_neck" || answers.pet_size) petFlow.splice(1, 0, PET_SIZE_QUESTION);
      return petFlow.concat(EXTRA_QUESTIONS.user_pet);
    }

    if (userType === "user_baby") {
      return BABY_QUESTIONS;
    }

    const flow = COMMON_QUESTIONS.slice();
    // `|| answers.size || answers.gender` keeps the conditional questions in the
    // flow while the user navigates backwards, same pattern as before.
    if (answers.area === "area_neck" || answers.size || answers.gender) {
      // Gender only for adults: child necks differ by well under a band width
      // between sexes, so asking would add friction without changing the answer.
      if (userType === "user_adult") {
        flow.splice(2, 0, GENDER_QUESTION, SIZE_QUESTION);
      } else {
        flow.splice(2, 0, SIZE_QUESTION);
      }
    }
    if (answers.ownership === "has_ring" || answers.replacement_need) {
      flow.push(REPLACEMENT_QUESTION);
    }
    flow.push(EXTRA_QUESTIONS[userType] || EXTRA_QUESTIONS.user_adult);
    return flow;
  }

  // Largest possible flow length for a user type, with every conditional question
  // included. The progress bar uses this fixed total so inserting the size or
  // replacement question mid-flow never makes progress appear to jump backward.
  function getMaxFlowLength(userType) {
    const maxAnswers = { area: "area_neck", ownership: "has_ring", replacement_need: "_", size: "_", gender: "_" };
    return getQuestionFlow(userType, maxAnswers).length;
  }

  function getSummaryComment(recommendations) {
    if (!recommendations.length) return "";
    const all28 = recommendations.every((product) => product.name.indexOf("28°ICE") !== -1 || product.name.indexOf("28° ICE") !== -1);
    const all18 = recommendations.every((product) => product.name.indexOf("18°ICE") !== -1);
    if (all28) return "あなたには、じんわり優しい冷たさを日常に取り入れやすいタイプが合いそうです。";
    if (all18) return "あなたには、しっかり冷たさを感じやすいタイプが合いそうです。";
    return "用途・冷たさ・フィット感のバランスを見て、<br>相性のよい候補を並べました。";
  }

  const api = {
    PRODUCTS,
    QUESTIONS: COMMON_QUESTIONS,
    COMMON_QUESTIONS,
    REPLACEMENT_QUESTION,
    SIZE_QUESTION,
    GENDER_QUESTION,
    PET_SIZE_QUESTION,
    PET_QUESTIONS,
    BABY_QUESTIONS,
    EXTRA_QUESTIONS,
    USER_OPTIONS,
    RESULT_NOTES,
    SIZE_GUIDES,
    RANK_LABELS,
    MATCH_LABELS,
    ANSWER_LABELS,
    NEUTRAL_TAGS,
    getWeight,
    normalizeTags,
    isEligible,
    calcScore,
    getMatchTags,
    resolveSizeForProduct,
    measuresFromTags,
    calculateRecommendations,
    getQuestionFlow,
    getMaxFlowLength,
    getSummaryComment
  };

  root.SUO_DIAG_DATA = api;
  if (typeof module !== "undefined" && module.exports) {
    module.exports = api;
  }
})(typeof window !== "undefined" ? window : globalThis);
